import { create } from 'zustand';

type AppStore = {
    accordionMenu: boolean;
    isSidebarCollapsed: boolean;
    setAccordionMenu: (value: boolean) => void;
    setSidebarCollapsed: (value: boolean) => void;
    toggleSidebarCollapsed: () => void;
};

export default create<AppStore>((set) => ({
    accordionMenu: false,
    isSidebarCollapsed: false,
    setAccordionMenu: (value) => set({ accordionMenu: value }),
    setSidebarCollapsed: (value) => set({ isSidebarCollapsed: value }),
    toggleSidebarCollapsed: () => set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),
}));
